@defer {
  @if (!subscriptionResource.error()) {
    <div class="availability-export">
      <div class="container">
        <availability-export-header [title]="customerDescription()" [productType]="productType" />
        <section>
          <table>
            <thead>
              <tr>
                <th colspan="4">{{ "Page.AvailabilityExport.ServiceDetails" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th width="16%">{{ "ServiceElement.Owner" | translate }}</th>
                <td width="34%">{{ subscription()?.organisation }}</td>
                <th width="16%">{{ "ServiceElement.Start" | translate }}</th>
                <td width="34%">{{ subscription()?.startDate | subscription_date }}</td>
              </tr>
              <tr>
                <th>{{ "ServiceElement.OwnAlias" | translate }}</th>
                <td>{{ customerDescriptionExists()! ? customerDescription() : "-" }}</td>
                <th>{{ "ServiceElement.SURFnetDescription" | translate }}</th>
                <td>{{ description()! }}</td>
              </tr>
              <tr>
                <th>{{ "ServiceElement.ServiceID" | translate }}</th>
                <td>{{ subscriptionId()! | shorten_guid }}</td>
                <th>{{ "ServiceElement.ServiceSpeed" | translate }}</th>
                <td>{{ subscription()?.serviceSpeed | service_speed }}</td>
              </tr>
              <tr>
                <th>{{ "ServiceElement.Domain" | translate }}</th>
                <td>{{ subscription()?.domain }}</td>
                <th>{{ "Page.AvailabilityExport.URL" | translate }}</th>
                <td>{{ url() }}</td>
              </tr>
            </tbody>
          </table>

          <h2>{{ "Page.AvailabilityExport.Heading1" | translate }}</h2>
          @if (slsReport.isLoading()) {
            <loader />
          } @else if (slsReport.error()) {
            <div>{{ "SLA.Report.LoadError" | translate }}</div>
          } @else if (!slsReport.value()) {
            <div>{{ "Page.AvailabilityExport.NotFound" | translate }}</div>
          } @else {
            <table>
              <thead>
                <tr>
                  <th width="16%">{{ "Page.AvailabilityExport.Month" | translate }}</th>
                  <th width="16%">{{ "Page.AvailabilityExport.Availability" | translate }}</th>
                  <th width="68%">{{ "Page.AvailabilityExport.ServiceTickets" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ "Page.AvailabilityExport.LastYear" | translate }}</td>
                  <td>{{ slsReport.value()!.yearAvailability }}%</td>
                  <td>&nbsp;</td>
                </tr>
                @for (row of slsReport.value()!.months; track $index) {
                  <tr>
                    <td>{{ row.date.getMonth() | monthname: 3 }}, {{ row.date.getFullYear() }}</td>
                    <td>{{ row.availability }}%</td>
                    <td>
                      @for (event of row.events; track $index) {
                        <div>
                          @if (event.description) {
                            <strong [innerHtml]="event.description | sls_event_description | safe: 'html'"></strong>
                          }
                          <span>
                            &nbsp;{{ "SlsReport.Event.From" | translate }}&nbsp;
                            @if (event.startTime) {
                              {{ event.startTime * 1000 | date: "yyyy-MM-dd HH:mm:ss" }}
                            }
                            -
                            @if (event.endTime) {
                              {{ event.endTime * 1000 | date: "yyyy-MM-dd HH:mm:ss" }}
                            }
                          </span>
                          <div>
                            <strong>{{ "Page.AvailabilityExport.Impact" | translate }}</strong> {{ event.impact }}
                          </div>
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </section>
        <availability-export-footer [description]="description()" />
      </div>
    </div>
  }
} @loading {
  <loader />
}
